import { KeyWordPosition } from '../slices/story-reading/story-reading.slice.types.ts';
import { RenderableStoryLine } from '../types/story-reading.types.ts';

export interface WordCountResult {
  lines: number[];
  total: number;
}

export const mapToWordCount = (
  lines: RenderableStoryLine[],
  startPosition: KeyWordPosition,
  finalPosition: KeyWordPosition
): WordCountResult => {
  if (startPosition.line === finalPosition.line) {
    const wordCount = finalPosition.indexInLine - startPosition.indexInLine + 1;
    return {
      lines: [wordCount],
      total: wordCount,
    };
  }

  const firstLineWords = lines[startPosition.line].words.slice(startPosition.indexInLine).length;
  const middleLineWords = lines.slice(startPosition.line + 1, finalPosition.line).map((line) => line.words.length);
  const lastLineWords = lines[finalPosition.line].words.slice(0, finalPosition.indexInLine + 1).length;

  return {
    lines: [firstLineWords, ...middleLineWords, lastLineWords],
    total: firstLineWords + middleLineWords.reduce((acc, curr) => acc + curr, 0) + lastLineWords,
  };
};
